const ETIQUETAS = {
  date: "Fecha",
  fecha: "Fecha",
  fechaDesde: "Desde",
  fechaHasta: "Hasta",
  fecha_inicio: "Desde",
  fecha_fin: "Hasta",
  fechaEnvio: "Fecha de envío",
  fechaSolicitud: "Fecha de solicitud",
  fechaCaducidad: "Caducidad",
  fechaReclamacion: "Fecha de reclamación",
  fechaMaximaDeReclamacion: "Fecha máxima de reclamación",
  estados: "Estados",
  estado: "Estado",
  estadoEnvio: "Estado del envío",
  estadoOp: "Estado operativo",
  estadoLeido: "Lectura",
  status: "Estado",
  anomalia: "Incidencia",
  conIncidencia: "Incidencia",
  entregaSabado: "Entrega en sábado",
  origenEnvioProgramado: "Programados",
  origenRma: "RMA",
  esAdministrador: "Administrador",
  sinValoracion: "Sin valoración",
  diferenciaValoracion: "Diferencia de valoración",
  valoracionAplicada: "Valoración aplicada",
  tipo_devolucion: "Tipo de devolución",
  cpDestino: "CP destino",
  cpOrigen: "CP origen",
  cp_destino: "CP destino",
  cp_origen: "CP origen",
  idFiscal: "ID fiscal",
  idCliente: "Cliente",
  IdRemesa: "Remesa",
  Remesa: "Remesa",
  codigo: "Código",
  codigoTarifa: "Código de tarifa",
  numero: "Número",
  numeroFactura: "Nº de factura",
  numeroRemesa: "Nº de remesa",
  numeroEfecto: "Nº de efecto",
  courierMillaIntermedia: "Transportista",
  courier: "Transportista",
  partner: "Partner",
  user: "Usuario",
  email: "Email",
  filename: "Archivo",
  nombreArchivo: "Archivo",
  descripcion: "Descripción",
  geografico: "Geográfico",
  ubicacion: "Ubicación",
  articulo: "Artículo",
  formaPago: "Forma de pago",
};

const CAMPOS_ENUMERADOS = new Set([
  "estados", "estado", "estadoEnvio", "estadoOp", "estadoLeido", "status",
  "roles", "geografico", "tipo", "tipo_devolucion", "existencia",
  "normalizada", "motivo", "origen", "activo", "ocurrencia",
]);
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const NUMERO_MES = {
  ene: 0, jan: 0, feb: 1, mar: 2, abr: 3, apr: 3, may: 4, jun: 5,
  jul: 6, ago: 7, aug: 7, sep: 8, sept: 8, oct: 9, nov: 10, dic: 11, dec: 11,
};

function tieneValor(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return Boolean(value.trim());
  if (Array.isArray(value)) return value.some(tieneValor);
  if (value instanceof Date) return !Number.isNaN(value.getTime());
  if (typeof value === "object") return Object.values(value).some(tieneValor);
  return true;
}

function etiquetaCampo(key) {
  if (ETIQUETAS[key]) return ETIQUETAS[key];
  const label = key.replace(/_/g, " ")
    .replace(/([a-záéíóúñ0-9])([A-ZÁÉÍÓÚÑ])/g, "$1 $2");
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function fechaCalendario(value) {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return { dia: value.getDate(), mes: value.getMonth(), ano: value.getFullYear() };
  }
  if (typeof value !== "string") return null;
  const text = value.trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const formatted = text.match(/^(\d{1,2})\/([a-z.]+|\d{1,2})\/(\d{4})$/i);
  if (!iso && !formatted) return null;
  const dia = Number(iso ? iso[3] : formatted[1]);
  const ano = Number(iso ? iso[1] : formatted[3]);
  const month = iso ? iso[2] : formatted[2];
  const mes = /^\d+$/.test(month) ? Number(month) - 1 : NUMERO_MES[month.toLowerCase().replace(/\./g, "")];
  const date = new Date(ano, mes, dia);
  if (date.getFullYear() !== ano || date.getMonth() !== mes || date.getDate() !== dia) return null;
  return { dia, mes, ano };
}

function fechaCompleta(date) {
  return `${date.dia} ${MESES[date.mes]} ${date.ano}`;
}

function fechaLegible(value) {
  const parts = Array.isArray(value) ? value : typeof value === "string" ? value.split(/\s+-\s+/) : [value];
  if (parts.length === 1) {
    const date = fechaCalendario(parts[0]);
    return date ? fechaCompleta(date) : null;
  }
  if (parts.length !== 2) return null;
  const start = fechaCalendario(parts[0]);
  const end = fechaCalendario(parts[1]);
  if (!start || !end) return null;
  if (start.ano === end.ano && start.mes === end.mes) {
    return start.dia === end.dia ? fechaCompleta(start) : `${start.dia}–${end.dia} ${MESES[end.mes]} ${end.ano}`;
  }
  if (start.ano === end.ano) {
    return `${start.dia} ${MESES[start.mes]} – ${fechaCompleta(end)}`;
  }
  return `${fechaCompleta(start)} – ${fechaCompleta(end)}`;
}

function enumLegible(value) {
  const traducciones = { ACTIVED: "Activado", DESACTIVED: "Desactivado" };
  if (traducciones[value]) return traducciones[value];
  const text = value.replace(/_/g, " ");
  const sentence = text.toLocaleLowerCase("es-ES");
  return (sentence.charAt(0).toUpperCase() + sentence.slice(1))
    .replace(/\b(rma|sepa|dni|nif|cif|iban|iva|api)\b/gi, (acronimo) => acronimo.toUpperCase());
}

function valorLegible(key, value) {
  if (typeof value === "boolean") return value ? "Sí" : "No";
  if (Array.isArray(value)) return value.filter(tieneValor).map((item) => valorLegible(key, item)).join(", ");
  if (value instanceof Date) return fechaLegible(value) || String(value);
  if (typeof value === "object") {
    const label = ["nombre", "label", "name", "codigo", "value", "_id"].find((field) => tieneValor(value[field]));
    return label ? String(value[label]) : Object.entries(value)
      .filter(([, item]) => tieneValor(item))
      .map(([field, item]) => `${etiquetaCampo(field)}: ${valorLegible(field, item)}`).join(", ");
  }
  const text = String(value).trim();
  return CAMPOS_ENUMERADOS.has(key) ? text.split(/\s*,\s*/).map(enumLegible).join(", ") : text;
}

// Solo prepara textos de presentación; no modifica los filtros recibidos.
export function prepararResumenFiltros(filters) {
  return Object.entries(filters || {})
    .filter(([key, value]) => !["sort", "order"].includes(key) && tieneValor(value))
    .map(([key, value]) => {
      const esFecha = key === "date" || /^fecha/i.test(key);
      const fecha = esFecha ? fechaLegible(value) : null;
      return { key, label: etiquetaCampo(key), value: fecha || valorLegible(key, value), esFecha };
    });
}
